import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-item-compensates',
    name: 'pay-item-compensate',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-item-compensate')
  }
]
